Vue.filter("timeSpent", function (input) {

    var timeSpent = parseInt(input);

    if (timeSpent < 0 || isNaN(timeSpent)) {
        timeSpent = 0;
    }
    var hours = Math.floor(timeSpent / 3600);
    var minutes = Math.floor((timeSpent % 3600) / 60);
    var seconds = timeSpent % 60;
    return sprintf("%02d:%02d:%02d", hours, minutes, seconds);
});
Vue.filter('formatTime', function (value, format) {
    return clockWork.getTimeFormatted(format, value);
});
Vue.filter("did8", function (input) {
    var regex = input.split(/(\d{4})/);
    var clean = regex.filter(
        function (input) {
            return !(input == "")
        });
    return clean.join(" ");
});
Vue.filter("toUpperCase", function(string) {
	return string.toUpperCase();
});
